module.exports = __webpack_public_path__ + "img/cover23.1172b1a2.png";